import { createRequestBody } from '../../context/DatasetFormDataContext/utils/createRequestBody';
import { LayoutInlineForm } from '../../types/types';

// Layout payload (canvas / object / matrix values) built the same way as the
// dataset form submit (createRequestBody). One exception: a picture field is
// sent only when the values carry it — value = replace, null = clear,
// missing = server keeps the stored bitmap.
export const createLayoutRequestBody = <T extends Record<string, unknown>>(
  values: T,
  form: LayoutInlineForm | undefined,
  method: 'POST' | 'PUT'
): T => {
  if (!form) {
    return values;
  }

  const body = createRequestBody(form, values, values, method);

  // FE-only object identity — never part of the payload.
  delete body.feKey;

  form.items.forEach((item) => {
    const isPicture =
      item.control?.type === 'picture' || item.type === 'binary';

    if (item.name && isPicture && !(item.name in values)) {
      delete body[item.name];
    }
  });

  return body as T;
};
